import { useState, useEffect } from "react";
import { CompareSchoolsStar } from "../../../../utils/DataLayers";

const useCollegesManager = ({
  colleges,
  favorite,
  ipedsId,
  selectAsFavorite,
  unselectAsFavorite,
  setNewSortOrderColleges
}) => {
  const [collegesLocal, setSchoolsLocal] = useState([]);
  const [favoriteLocal, setFavoriteLocal] = useState(null);
  const [originalSchoolOrder, setOriginalSchoolOrder] = useState([]);

  useEffect(() => {
    setSchoolsLocal(colleges);
    setFavoriteLocal(favorite);
    setOriginalSchoolOrder(colleges.map((s) => s.pairedId));
  }, [colleges, favorite]);

  const selectAsFavoriteLocal = (college) => {
    CompareSchoolsStar({ ipeds: ipedsId });

    const allColleges = favoriteLocal
      ? [favoriteLocal, ...collegesLocal]
      : collegesLocal;

    const newSchools = allColleges.map((school) => ({
      ...school,
      isFavorite: school.pairedId === college.pairedId
    }));

    setFavoriteLocal(newSchools.find((school) => school?.isFavorite));
    setSchoolsLocal(newSchools.filter((school) => !school?.isFavorite));
    selectAsFavorite(college);
  };

  const unselectAsFavoriteLocal = () => {
    const newSchools = [favoriteLocal, ...collegesLocal].map((school) => ({
      ...school,
      isFavorite: false
    }));

    setFavoriteLocal(null);
    setSchoolsLocal(newSchools);
    unselectAsFavorite(favoriteLocal);
  };

  const moveItem = (dragId, hoverId, dropped = false) => {
    if (dragId === hoverId) return;

    let dragIndex = -1,
      hoverIndex = -1;
    for (let i = 0; i < collegesLocal.length; i++) {
      if (collegesLocal[i].school.ipedsId === dragId) {
        dragIndex = i;
      } else if (collegesLocal[i].school.ipedsId === hoverId) {
        hoverIndex = i;
      }
      if (dragIndex !== -1 && hoverIndex !== -1) {
        break;
      }
    }

    if (dropped) {
      const newOrder = collegesLocal.map((school) => school.pairedId);
      if (!newOrder.every((id, index) => id === originalSchoolOrder[index])) {
        setNewSortOrderColleges(dragId, hoverId);
        setOriginalSchoolOrder(newOrder);
      }
      return;
    }

    if (dragIndex === -1 || hoverIndex === -1) return;

    const newSchools = [...collegesLocal];
    const [draggedItem] = newSchools.splice(dragIndex, 1);
    newSchools.splice(hoverIndex, 0, draggedItem);

    setSchoolsLocal(newSchools);
  };

  return {
    collegesLocal,
    favoriteLocal,
    moveItem,
    selectAsFavoriteLocal,
    unselectAsFavoriteLocal
  };
};

export default useCollegesManager;
